import type {Course} from "../../types/course/Course.tsx";
import CourseGrid from "../../components/course/course-grid/CourseGrid.tsx";
import CourseFilter from "../../components/course/course-filter/CourseFilter.tsx";
import CourseService from '../../services/course/CourseService';
import { useEffect, useState } from 'react';

function CoursesOverviewPage() {
    const [courses, setCourses] = useState([]);
    const [filtered, setFiltered] = useState([]);

    useEffect(() => {
        CourseService.fetchAll().then((data) => {
            setCourses(data);
            setFiltered(data);
        });
    }, []);

    const handleFilter = (category: string, level: string, search: string) => {
        let result = courses;

        if (category !== 'all') {
            result = result.filter(c => c.category.toLowerCase() === category.toLowerCase());
        }
        if (level !== 'all') {
            result = result.filter(c => c.level.toLowerCase() === level.toLowerCase());
        }
        if (search) {
            result = result.filter(c => c.title.toLowerCase().includes(search.toLowerCase()));
        }

        setFiltered(result);
    };

    return (
        <div className="container">
            <CourseFilter onFilter={handleFilter} />
            <CourseGrid courses={filtered} />
        </div>
    );
}

export default CoursesOverviewPage;
